import React from "react";
import { Link } from 'react-router-dom';

function FooterLinks() {
    return (
        <div className="links">
            <Link
                to="https://1424.lt/privatumo-politika/"
                style={{ textDecoration: 'underline', color: '#333' }}
            >
                Privatumo politika
            </Link>
            <Link
                to="https://1424.lt/taisykles-ir-salygos/"
                style={{ textDecoration: 'underline', color: '#333' }}
            >
                Taisyklės ir sąlygos
            </Link>
            <Link
                to="https://1424.lt/grazinimo-politika/"
                style={{ textDecoration: 'underline', color: '#333' }}
            >
                Grąžinimo politika
            </Link>
            <Link
                to="https://1424.lt/rezervacija/"
                style={{ textDecoration: 'underline', color: '#333' }}
            >
                Išankstinių rezervacijų sąlygos
            </Link>
        </div>
    );
}

export default FooterLinks;
